export const logIfDevelopment = (...logArgs: unknown[]): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...logArgs);
  }
};
